import './ImagePreviewModal.css';
import ModalDialog from '../modalDialog/ModalDialog';
import ModalDialogContent from '../modalDialog/modalDialogContent/ModalDialogContent';

const ImagePreviewModal = ({ imageSrc, onClose }) => {
	const handleCloseModal = (e) => {
		if (onClose) {
			onClose(e);
		}
	};

	return (
		<ModalDialog className="image-preview-container" backgroundClassName="image-preview-modal-background">
			<ModalDialogContent className="p-0">
				{imageSrc && <img className="" src={imageSrc} />}
				<button
					href="#"
					className="btn btn-link btn-close-preview"
					onClick={(e) => handleCloseModal(e)}
					title="Close"
				>
					<i className="fa-solid fa-times me-0" />
				</button>
			</ModalDialogContent>
		</ModalDialog>
	);
};

export default ImagePreviewModal;
